import { createSlice } from "@reduxjs/toolkit"
import {toast, ToastContainer } from "react-toastify";

export const loginForgetPassSlice = createSlice({
	name: "forget_password",
	initialState: {
		forgetPassMessage: "",
		reset_phone: "",
		errors: [],
	},

	reducers: {
		getForgetPassMessage: (state, action) => {
			state.forgetPassMessage = action.payload
             console.log(action.payload, 'from for get pass reducer');
		},
		getUserNewPhone: (state, action) => {
			state.reset_phone = action.payload.phone
			// console.log(action.payload, "reducer")
		},
		getForgetPassMessageSuccess: (state, action) => {
			state.forgetPassMessage = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
			
			if(action.payload.non_field_errors){
				toast.error(`${action.payload.non_field_errors}`, {
					position: "top-right",
					autoClose: 1500,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}
		 
		},
	},
})

// Action creators are generated for each case reducer function
export const {getForgetPassMessage, getForgetPassMessageSuccess, getErrors, getUserNewPhone} = loginForgetPassSlice.actions

export default loginForgetPassSlice.reducer
